export let DomainIntentType = /*#__PURE__*/function (DomainIntentType) {
  DomainIntentType["CONNECT"] = "connect";
  DomainIntentType["CONNECT_DROPSHIPPING"] = "connect-dropshipping";
  DomainIntentType["CONNECT_FUNNEL"] = "connect-funnel";
  DomainIntentType["PURCHASE"] = "purchase";
  DomainIntentType["PURCHASE_DROPSHIPPING"] = "purchase-dropshipping";
  DomainIntentType["PURCHASE_STOREFRONT"] = "purchase-storefront";
  DomainIntentType["PURCHASE_FUNNEL"] = "purchase-funnel";
  return DomainIntentType;
}({});
export const DOMAIN_INTENT_REFERRAL_VALUES = {
  [DomainIntentType.CONNECT]: 'add-domain-connect-intent',
  [DomainIntentType.CONNECT_DROPSHIPPING]: 'add-domain-connect-intent-dropshipping',
  [DomainIntentType.CONNECT_FUNNEL]: 'add-domain-connect-intent-funnel',
  [DomainIntentType.PURCHASE]: 'add-domain-purchase-intent',
  [DomainIntentType.PURCHASE_DROPSHIPPING]: 'add-domain-purchase-intent-dropshipping',
  [DomainIntentType.PURCHASE_STOREFRONT]: 'add-domain-purchase-intent-storefront',
  [DomainIntentType.PURCHASE_FUNNEL]: 'add-domain-purchase-intent-funnel'
};
export const getDomainIntentType = referralAdditionalInfo => {
  if (!referralAdditionalInfo) {
    return undefined;
  }
  const entry = Object.entries(DOMAIN_INTENT_REFERRAL_VALUES).find(_ref => {
    let [, value] = _ref;
    return value === referralAdditionalInfo;
  });
  return entry ? entry[0] : undefined;
};
export const isBaseDomainPurchaseIntentReferral = referralAdditionalInfo => {
  const intentType = getDomainIntentType(referralAdditionalInfo);
  return intentType === DomainIntentType.PURCHASE || intentType === DomainIntentType.PURCHASE_FUNNEL;
};
//# sourceMappingURL=domainIntentReferrals.js.map